export default function SuspenseComponentText(props) {


    return (
        `Loading...`
    )
}